export default __webpack_public_path__ + "static/media/travelGuru.be926500.PNG";